module.exports = __webpack_public_path__ + "img/taoyuan-3.6d9ee963.jpg";